import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "@app/lib/utils";

export const badgeVariants = cva(
  "inline-flex min-w-0 shrink-0 items-center justify-center gap-1.5 border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 [&_svg]:stroke-[2]",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary/10 text-primary shadow-none hover:bg-primary/15",
        secondary:
          "border-transparent bg-muted text-muted-foreground hover:bg-muted/80",
        destructive:
          "border-transparent bg-destructive/10 text-destructive shadow-none hover:bg-destructive/15",
        success:
          "border-transparent bg-success/10 text-success hover:bg-success/15",
        warning:
          "border-transparent bg-warning/10 text-warning hover:bg-warning/15",
        info: "border-transparent bg-info/10 text-info hover:bg-info/15",
        outline: "text-foreground",
        outlinePrimary: "border-primary/25 bg-transparent text-primary",
        outlineSuccess: "border-success/25 bg-transparent text-success",
        outlineDestructive:
          "border-destructive/25 bg-transparent text-destructive",
        outlineWarning: "border-warning/25 bg-transparent text-warning",
        outlineInfo: "border-info/25 bg-transparent text-info",
        outlineMuted: "border-border bg-transparent text-muted-foreground",
      },
      size: {
        xs: "h-5 rounded-md px-1.5 text-2xs leading-4",
        sm: "h-6 rounded-md px-2 text-xs leading-5",
        md: "h-7 rounded-md px-2.5 text-xs leading-5",
        lg: "h-8 rounded-md px-3 text-sm leading-5",
        none: "rounded-md p-0",
      },
      shape: {
        default: "rounded-md",
        pill: "rounded-full",
        square: "rounded-md px-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      shape: "default",
    },
  },
);

export interface BadgePrimitiveProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function BadgePrimitive({
  className,
  variant,
  ...props
}: BadgePrimitiveProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
